import AccessGroupsRoute from '@/features/admin/access-groups/AccessGroupsRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/groups')({
  component: AccessGroupsRoute,
});
